import { useParams } from 'react-router-dom';
import AdvertisementForm from './AdvertisementForm';

const EditAdvertisement = () => {
  const { id } = useParams();
  return <AdvertisementForm mode="edit" id={id} />;
};

export default EditAdvertisement;
